{
"catalog": {
" / mo": " / m\u00e5ned",
" / yr": " / \u00e5r",
" company has been added": " Den nye virksomhed er blevet tilf\u00f8jet",
" day. Renew now to continue enjoying uninterrupted access.": " dag. Forny nu for at forts\u00e6tte med at nyde uafbrudt adgang.",
" days. Renew now to continue enjoying uninterrupted access.": " dage. Forny nu for at forts\u00e6tte med at nyde uafbrudt adgang.",
"${keyToDelete?.key}": "${keyToDelete?.key}",
"(DKK/m\u00b3)": "(DKK/m\u00b3)",
"(\u00d8re/kWh)": "(\u00d8re/kWh)",
"0.00": "0,00",
"1 (Fixed)": "1 (fast)",
"3 plans": "3 planer",
"3 reports": "3 rapporter",
"4 offerings": "4 tilbud",
": The new company has been added": ": Den nye virksomhed er blevet tilf\u00f8jet",
"A code of reference ( Who referred a company)": "En referencekodeks ( Hvem har henvist en virksomhed)",
"A link has been sent to your email address to reset password": "Der er blevet sendt et link til din mail, s\u00e5 du kan nulstille din adgangskode",
"A link has been sent to your email address to reset password.": "Der er sendt et link til din e-mailadresse, s\u00e5 du kan nulstille din adgangskode.",
"A newer version of this application is available. The update will begin automatically in 20 seconds.": "En nyere version af denne applikation er tilg\u00e6ngelig. Opdateringen starter automatisk om 20 sekunder.",
"A suspicious activity was detected. For security reasons, you must log in again": "En mist\u00e6nkelig aktivitet blev opdaget. Af sikkerhedsm\u00e6ssige \u00e5rsager skal du logge ind igen",
"API Documentation": "API-dokumentation",
"API Key": "API-n\u00f8gle",
"API access": "API-adgang",
"API access plans": "Planer for API-adgang",
"API integration": "API-integration",
"API key": "API-n\u00f8gle",
"Access Denied": "Adgang n\u00e6gtet",
"Access from partner website": "Adgang fra partnerens hjemmeside",
"Access given": "Adgang givet",
"Access is Required!": "Adgang er p\u00e5kr\u00e6vet!",
"Access period": "Adgangsperiode",
"Account Setup": "Kontoops\u00e6tning",
"Account creation code": "Kode for oprettelse af konto",
"Action": "Handling",
"Action Required": "Handling p\u00e5kr\u00e6vet",
"Actions": "Handlinger",
"Active": "Aktiv",
"Active Child Company": "Active Child Company",
"Active Corporate Group": "Aktiv koncern",
"Active Parent Company": "Aktiv moderselskab",
"Active Partner": "Aktiv partner",
"Active Role": "Aktiv rolle",
"Active Users": "Aktiv",
"Active Users List": "Liste over aktive brugere",
"Add": "Tilf\u00f8j",
"Add Corporate Group": "Tilf\u00f8j koncern",
"Add Corporate Key": "Tilf\u00f8j koncernn\u00f8gle",
"Add Customer": "Tilf\u00f8j kunde",
"Add Global Key": "Tilf\u00f8j global n\u00f8gle",
"Add Historical Data Limit": "Tilf\u00f8j historisk datagr\u00e6nse",
"Add Key": "Tilf\u00f8j n\u00f8gle",
"Add New Corporate Group": "Tilf\u00f8j ny koncern",
"Add New Feature": "Tilf\u00f8j ny funktion",
"Add New Module": "Tilf\u00f8j nyt modul",
"Add New Partner": "Tilf\u00f8j ny partner",
"Add New Subscription": "Tilf\u00f8j et nyt abonnement",
"Add New User": "Tilf\u00f8j en ny bruger",
"Add Partner": "Tilf\u00f8j Partner",
"Add Partner Key": "Tilf\u00f8j partnern\u00f8gle",
"Add User": "Tilf\u00f8j bruger",
"Add User Key": "Tilf\u00f8j bruger n\u00f8gle",
"Add a new role": "Tilf\u00f8j en ny rolle",
"Add company": "Tilf\u00f8j virksomhed",
"Add contract": "Tilf\u00f8j kontrakt",
"Add feature": "Tilf\u00f8j funktion",
"Add permission": "Tilf\u00f8j tilladelse",
"Add role": "Tilf\u00f8j rolle",
"Add subscription plan": "Tilf\u00f8j abonnementsplan",
"Additional Users": "Ekstra brugere",
"Address": "Adresse",
"Address 1": "Adresse 1",
"Address 2": "Adresse 2",
"Aggregated": "Samlet",
"Alias": "Alias",
"All": "Alle",
"All Clear": "Delete alle",
"All Documents": "Alle dokumenter",
"All Orphaned": "Alle ikke tilknyttede brugere",
"All Partners": "Alle partnere",
"All Users": "Alle Brugere",
"All Users (Any Role)": "Alle Brugere (alle roller)",
"All corporate group settings saved successfully!": "Koncernindstillingerne er gemt!",
"All in Role": "Alle brugere har en rolle",
"All kWh": "Alle kWh",
"All notifications deleted successfully": "Alle beskeder er slettet",
"All notifications marked as read": "Alle meddelelser markeret som l\u00e6st",
"All system settings saved successfully!": "Alle systemindstillinger er blevet gemt.",
"All user settings saved successfully!": "Alle brugerindstillinger er blevet gemt.",
"Alpha numeric and dash only": "Kun alfanumerisk og bindestreg",
"Already Deleted": "Allerede slettet",
"Already have an account?": "Har du allerede en konto?",
"Amount of money for consumption": "Forbrugsomkostning",
"An error occurred": "Der opstod en fejl",
"An error occurred while deleting the document": "Der opstod en fejl under sletning af dokumentet",
"An error occurred while the system was generating the report. Please try again. You can contact support If this continues.": "Der opstod en fejl, da systemet lavede rapporten. Pr\u00f8v venligst igen. Du kan kontakte support, hvis dette forts\u00e6tter.",
"An unexpected error occurred while processing your request. Please try refreshing the page or return to the dashboard.": "Der opstod en uventet fejl under behandlingen af \u200b\u200bdin anmodning. Pr\u00f8v venligst at opdatere siden eller vend tilbage til betjeningspanelet.",
"An unexpected error occurred. It has been logged, and we are working on a resolution.": "Der opstod en uventet fejl. Den er blevet logget, og vi arbejder p\u00e5 en l\u00f8sning.",
"Analyze Pricing Tiers": "Analyser prisniveauer",
"Analyze Usage Trends": "Analyser brugstendenser",
"Annual CO\u2082e (Kg)": "\u00c5rlig CO\u2082e (kg)",
"Annual Statement": "\u00c5rsopg\u00f8relse",
"Annual energy consumption (kWh)": "\u00c5rligt energiforbrug (kWh)",
"App": "App",
"App URL": "App-URL",
"Apr": "Apr",
"Apr: Checking": "Apr: Tjekker",
"Apr: Get": "Henter Apr data",
"Apr: Update": "Apr: Opdaterer",
"April": "April",
"Are you sure you want to delete this notification ? ": "Er du sikker p\u00e5, at du vil slette denne meddelelse? ",
"Are you sure you want to delete?": "Er du sikker p\u00e5 du \u00f8nsker at slette?",
"Are you sure you want to set the status to 'Deleted' for %s user(s) matching '%role%' who have no corporate groups?": "Er du sikker p\u00e5, at du vil \u00e6ndre status til 'Slettet' for %s bruger(e), der matcher '%role%', og som ikke er tilknyttet nogen koncerner?",
"Attach Company with User": "Tilknyt virksomhed til bruger",
"Aug": "Aug",
"Aug: Checking": "Aug: Tjekker",
"Aug: Get": "Henter Aug data",
"Aug: Update": "Aug: Opdaterer",
"August": "August",
"Authority Processing": "Myndighedsbehandling",
"Authorization": "Godkendelse",
"Automate Budget Tracking": "Automatiser budgetopf\u00f8lgning",
"Automate Sustainability Tracking": "Automatis\u00e9r sporing af b\u00e6redygtighed",
"Automate Usage Tracking": "Automatiser sporing af forbrug",
"Availability Payment": "R\u00e5dighedsbetaling",
"Availability Rate": "R\u00e5dighedstarif",
"Back": "Tilbage",
"Back to": "Tilbage til",
"Back to Dashboard": "Tilbage til Kontrolpanel",
"Back to Documents": "Tilbage til dokumenter",
"Basic Information": "Grundl\u00e6ggende oplysninger",
"Before getting started, could you verify your email address by ": "F\u00f8r du g\u00e5r i gang, bedes du bekr\u00e6fte din e-mailadresse ved at ",
"Benchmark Provider Rates": "Benchmark for leverand\u00f8rtakster",
"Benchmark your rates. Input your current energy contract details to compare your actual provider rates against live market data, helping you spot better deals and ensure you are never overpaying.": "Sammenlign dine takster. Indtast oplysningerne om din nuv\u00e6rende energiaftale for at sammenligne dine aktuelle priser med markedsdata i realtid \u2013 s\u00e5 kan du finde bedre tilbud og sikre, at du aldrig betaler for meget.",
"Bidding Zone": "Budzone",
"Billing Cycle:": "Faktureringsperiode:",
"Billing Period:": "Betalingsperiode:",
"Blocked": "Blokeret",
"Boost Efficiency": "Forbedring af energieffektivitet",
"Budget": "Budget",
"Budget Date Future Years": "Budgetdato for fremtidige \u00e5r",
"Budget Date Past Years": "Budgetdato for tidligere \u00e5r",
"Budget data, prices, tariffs, taxes and cost": "Budget, priser, tariffer, afgifter samt omkostninger",
"Building": "Bygning",
"Building address": "Bygningens adresse",
"Building is required": "Bygning er p\u00e5kr\u00e6vet",
"But you still need to know more.": "Men du har stadig brug for at vide mere.",
"CAPTCHA verification failed. Please try again.": "CAPTCHA-verificering mislykkedes. Pr\u00f8v igen.",
"CCPA Privacy Rights (Do Not Sell My Personal Information)": "CCPA's rettigheder til beskyttelse af personlige oplysninger (S\u00e6lg ikke mine personlige oplysninger)",
"CO\u2082_per_m2": "CO\u2082_per_m2",
"CO\u2082e": "CO\u2082e",
"CO\u2082e (Kg)": "CO\u2082e (kg)",
"CVR": "CVR",
"Cached": "Cached",
"Cancel": "Fortryd",
"Capture Immediate Spikes": "Fang pludselige stigninger",
"Carbon Emissions": "CO\u2082-udlening",
"Carbon Emissions (Kg CO\u2082e)": "CO\u2082-udledning (kg CO\u2082e)",
"Carbon Footprint": "CO2-aftryk",
"Carbon Footprint (g CO\u2082e/kWh)": "CO\u2082-aftryk (g CO\u2082e/kWh)",
"Carbon dioxide Consumption": "Forbrug af kuldioxid",
"Cashed Statement - Under Development": "Cashed Statement - Under udvikling",
"Central business Register number": "Centralt virksomhedsregisternummer",
"Change Password": "Opdater adgangskode",
"Change password": "Skift adgangskode",
"Chart Visualization Settings": "Indstillinger for diagramvisualisering",
"Checking Cache": "Kontrol af cache",
"Checkout Invoice": "Betalingsfaktura",
"Checkout Invoice Summary": "Oversigt over faktura ved betaling",
"Child Companies": "Datterselskab",
"Child Company": "Virksomhed",
"Child company and above level access": "Virksomhed og adgang p\u00e5 h\u00f8jere niveau",
"City": "By",
"Cleanup Orphaned Users Without Corporate Groups": "Administrer og opryd i brugere uden tilknyttede virksomhedsgrupper.",
"Clear above cache": "Ryd cache",
"Clear all cache": "Ryd al cache",
"Clear browser memory / Page reload": "Ryd browserhukommelse / Genindl\u00e6s side",
"Click to copy": "Klik for at kopiere",
"Click to upload or drag and drop": "Klik for at uploade eller tr\u00e6k og slip",
"Climate": "Klima",
"Climate 1": "Klima 1",
"Climate Chart Type": "Klima diagram",
"Climate Date Future Years": "Klimadata for fremtidige \u00e5r",
"Climate Date Past Years": "Klimadata for tidligere \u00e5r",
"Climate Report": "Klimarapport",
"Climate Statement": "Klimapolitisk erkl\u00e6ring",
"Climate report": "Klimarapport",
"Close": "Luk",
"Co2 Certificates": "CO2-certifikater",
"Code": "Kode",
"Collaborative users allowed": "Brugere",
"Coming Soon": "Kommer snart",
"Commission Price": "Kommissions pris",
"Commission Share": "Kommissionens andel",
"Companies": "Virksomheder",
"Companies / Subsidiaries": "Virksomheder / Datterselskaber",
"Companies for ": "Virksomheder for ",
"Companies for the corporate group: ": "Virksomheder i koncernen: ",
"Company": "Virksomhed",
"Company Administration": "Virksomhedsadministration",
"Company Authenticity number": "Virksomhedens autenticitetsnummer",
"Company Location": "Virksomheds adresse",
"Company Locations": "Virksomheds adresse",
"Company Name": "Virksomhedsnavn",
"Company No.": "CVR-nr.",
"Company Number": "Virksomhedens nummer",
"Company Owner (Standard)": "Virksomhedsejer (Standard)",
"Company Roles": "Virksomhedens roller",
"Company Users": "Virksomhedsbrugere",
"Company Users for ": "Virksomhedsbrugere til ",
"Company name": "Virksomhedsnavn",
"Company website": "Firma Hjemmeside",
"Compare Market Data": "Sammenlign markedsdata",
"Compensation": "Godtg\u00f8relse",
"Complete Payment": "Gennemf\u00f8r betaling",
"Completed with %s succeeded and %s failed": "Fuldf\u00f8rt med %s lykkedes og %s mislykkedes",
"Compress Energy Spend": "Reducer energiudgifterne",
"Configure allowable past and future year selection limits (0 to 20 years) across system modules.": "Konfigurer gr\u00e6nser for valg af tidligere og fremtidige \u00e5r (0 til 20 \u00e5r) p\u00e5 tv\u00e6rs af systemmoduler.",
"Configure chart visualization preferences and date range selection limits.": "Konfigurer pr\u00e6ferencer for diagramvisualisering og gr\u00e6nser for valg af datointerval.",
"Configure chart visualization preferences for your corporate group.": "Ops\u00e6tning af diagrammer for din koncern.",
"Configure personal chart visualization preferences for your account.": "Konfigurer personlige pr\u00e6ferencer for visualisering af diagrammer for din konto.",
"Confirm Deletion of Orphaned Users": "Bekr\u00e6ft sletning af ikke tilknyttede brugere",
"Confirm Email Address": "Bekr\u00e6ft e-mail adresse",
"Confirm Password": "Bekr\u00e6ft adgangskode",
"Confirm password does not match.": "Bekr\u00e6ft adgangskode stemmer ikke overens.",
"Confirmation": "Bekr\u00e6ft",
"Confirming payment with Stripe...": "Bekr\u00e6fter betaling med Stripe...",
"Congratulations, you\u2019ve chosen the best energy spending platform": "Tillykke, du har valgt den bedste energiudgiftsplatform",
"Consent": "Samtykke",
"Consumption": "Forbrug",
"Consumption (kWh)": "Forbrug (kWh)",
"Consumption (m\u00b3)": "Forbrug (m\u00b3)",
"Consumption and CO\u2082e": "Forbrug og CO\u2082e",
"Consumption measured in kWh": "Forbrug (kWh)",
"Consumption measured in m\u00b3": "Forbrug m\u00e5lt i m\u00b3",
"Contact Name": "Kontakt navn",
"Contact Person": "Kontaktperson",
"Contact Phone": "Kontakttelefonnummer",
"Continue": "Forts\u00e6t",
"Contract list": "Kontaktliste",
"Contracts": "Kontrakter",
"Conversion Rate": "CO\u2082-aftryk",
"Conversion Rate for CO\u2082e": "CO\u2082-aftryk",
"Conversion rate in g CO\u2082e/kWh": "CO\u2082-aftryk i g CO\u2082e/kWh",
"Copied to clipboard": "Kopieret til udklipsholder",
"Core license access to the platform console, basic dashboarding, and report generation.": "Kernelicensadgang til platformskonsollen, grundl\u00e6ggende dashboard-funktionalitet og rapportgenerering.",
"Core license status": "Kernelicens status",
"Corporate Group": "Koncern",
"Corporate Group / Company Name": "Koncern",
"Corporate Group Roles": "Roller i koncernen",
"Corporate Group Settings": "Koncern indstillinger",
"Corporate Group has been deleted successfully.": "Koncernen er slettet.",
"Corporate Group is Required!": "Koncerner er p\u00e5kr\u00e6vet",
"Corporate Group?": "Koncern?",
"Corporate Groups": "Koncerner",
"Corporate Groups for the partner ": "Koncerner for partneren ",
"Corporate Keys": "Koncernn\u00f8gler",
"Corporate group and above level access": "Adgang til koncern og h\u00f8jere niveauer",
"Cost": "Omkostninger",
"Cost (DKK)": "Omkostninger (DKK)",
"Cost Chart Type": "Omkostnings diagram",
"Cost Compression": "Omkostningsreduktion",
"Cost Date Future Years": "Omkostning \u2013 dato \u2013 fremtidige \u00e5r",
"Cost Date Past Years": "Omkostninger \u2013 dato \u2013 tidligere \u00e5r",
"Cost in DKK": "Omkostninger (DKK)",
"Countries": "Lande",
"Country": "Land",
"Country code": "Landekode",
"Create Historical Data Limit": "Opret historisk datagr\u00e6nse",
"Create New Contract": "Opret ny kontrakt",
"Create a new password": "Opret en ny adgangskode",
"Create or get an API key to access your data.": "Opret eller f\u00e5 en API-n\u00f8gle til at f\u00e5 adgang til dine data.",
"Created At": "Oprettet af",
"Created By": "Oprettet af",
"Created Date": "Oprettet den",
"Currency": "Valuta",
"Currency is required": "Valuta er p\u00e5kr\u00e6vet",
"Currency:": "Valuta:",
"Current Password": "Nuv\u00e6rende adgangskode",
"Current Status": "Aktuel status",
"Current month only": "Kun den aktuelle m\u00e5ned",
"Current year only": "Kun indev\u00e6rende \u00e5r",
"Custom Setup & Implementation": "Skr\u00e6ddersyet ops\u00e6tning og implementering",
"Custom Setup (One-time)": "Brugerdefineret ops\u00e6tning (engangs-)",
"Customer": "Kunde",
"DKK": "DKK",
"DKK (kr.)": "DKK (kr.)",
"Daily": "Daglig",
"Danish": "Dansk",
"Dashboard": "Kontrolpanel",
"Data Delivered By": "Data leveret af",
"Data Your Way": "Data p\u00e5 dine pr\u00e6misser",
"Data granularity. PT1H = every 1 hour, PT15M = every 15 minutes": "Data detaljegrad. PT1H = hver 1 time, PT15M = hvert 15. minut",
"Data is currently being loaded. Please hold on a moment.": "Data er i \u00f8jeblikket ved at blive indl\u00e6st. Vent venligst et \u00f8jeblik.",
"Data refreshed successfully": "Data er blevet tilf\u00f8jet",
"Data validation - consumption": "Datavalidering - forbrug",
"DataHub": "DataHub",
"Date": "Dato",
"Date Range Settings": "Indstillinger for datointerval",
"Date when the access is given": "Dato, hvor der gives adgang",
"Day": "Dag",
"Day Report - Under development": "Dagsrapport - produceres",
"Days": "Dage",
"Dear {{user_full_name}}": "K\u00e6re {{user_full_name}}",
"Dec": "Dec",
"Dec: Checking": "Dec: Tjekker",
"Dec: Get": "Henter Dec data",
"Dec: Update": "Dec: Opdaterer",
"December": "December",
"Default chart visual types for Energy, Climate, Cost, and Budget dashboards.": "Standardvisningstyper for diagrammer til dashboards for energi, klima, omkostninger og budget.",
"Define setting keys to standardize setting information stored in the database.": "Defin\u00e9r indstillingsn\u00f8gler for at standardisere indstillingsoplysninger, der gemmes i databasen.",
"Delete": "Slet",
"Delete API Key": "Slet API-n\u00f8gle",
"Delete All Notifications": "Slet alle meddelelser",
"Delete Key": "Slet n\u00f8gle",
"Deleted": "Slettet",
"Description": "Beskrivelse",
"Developer": "Udvikler",
"Developer Tools": "Udviklerv\u00e6rkt\u00f8jer",
"Did you forget your password? Create a new one by clicking the button below.": "Har du glemt din adgangskode? Opret en ny ved at klikke p\u00e5 knappen nedenfor.",
"Did you get this email by mistake? If so no worries - you can just ignore it.": "Har du f\u00e5et denne e-mail ved en fejl? I s\u00e5 fald er der ingen grund til bekymring - du kan bare ignorere den.",
"Difference": "Forskel",
"Discount Net Tariff": "Rabat nettarif",
"Discount Subscription": "Rabat abonnement",
"Distribution": "Distribution",
"District Heating": "Fjernvarme",
"Do you know?": "Ved du?",
"Do you want to delete the document?": "Er du sikker p\u00e5, at du \u00f8nsker at slette denne leverand\u00f8r?",
"Do you want to delete the historical data limit?": "Vil du slette gr\u00e6nsen for historiske data?",
"Do you want to delete the notification?": "Vil du slette meddelelsen?",
"Do you want to unlink the company?": "Vil du fjerne forbindelsen til virksomheden?",
"Do you want to unlink the user?": "Vil du fjerne forbindelsen til brugeren?",
"Document Details": "Dokumentdetaljer",
"Document For": "Dokument til",
"Document Preview": "Dokumentforh\u00e5ndsvisning",
"Document Type": "Bilagstype",
"Document Uploading Failed": "Upload af dokument mislykkedes",
"Document deleted successfully": "Dokument slettet med succes",
"Document list": "Dokumentliste",
"Document not found": "Bilag blev ikke fundet",
"Document updated successfully": "Dokument opdateret med succes",
"Document uploaded successfully": "Dokumentet er blevet uploadet",
"Documents": "Dokumenter",
"Don't Have An Account Yet?": "Har du ikke en konto endnu?",
"Download": "Hent",
"Download Climate Report": "Hent klimarapport",
"Download Cost Report": "Hent omkostningsrapport",
"Download Document": "Download dokument",
"Download Emission History": "Download emissionshistorik",
"Download Energy Report": "Hent energirapport",
"Download Excel History": "Download Excel-historik",
"Download For App": "Download til app",
"Download For WWW": "Download til WWW",
"Download Rate Breakdowns": "Download prisopdelinger",
"Download Sport Price Report": "Hent prisrapport",
"Download Tariff Report": "Download tarifrapport",
"Download comprehensive Excel breakdowns of your energy pricing structures and rate plans. Easily analyze utility tariff charges, isolate peak versus off-peak costs, and identify the most cost-effective pricing tiers for your operations.": "Download omfattende Excel-oversigter over dine energiprisstrukturer og takstplaner. Analys\u00e9r nemt nettariffer, adskil omkostninger i spidsbelastningsperioder fra perioder med lav belastning, og identific\u00e9r de mest omkostningseffektive pristrin for din drift.",
"Download comprehensive, pre-formatted Excel sheets detailing your full consumption history. Instantly analyze your baseline usage, review demand trends, and share clean data with your team for auditing and planning.": "Download omfattende, pr\u00e6formaterede Excel-ark med detaljerede oplysninger om hele dit forbrugsforl\u00f8b. Analys\u00e9r \u00f8jeblikkeligt dit normale forbrugsniveau, gennemg\u00e5 forbrugstendenser, og del overskuelige data med dit team til brug for revision og planl\u00e6gning.",
"Download detailed Excel summaries of your environmental impact. Easily track your carbon footprint, review emission trends over time, and export the exact greenhouse gas metrics you need for corporate sustainability and compliance reporting.": "Download detaljerede Excel-oversigter over din milj\u00f8p\u00e5virkning. Spor nemt dit CO2-aftryk, gennemg\u00e5 emissionstendenser over tid, og eksporter de pr\u00e6cise drivhusgasm\u00e5linger, du har brug for til virksomhedens b\u00e6redygtigheds- og compliance-rapportering.",
"Download report": "Hent rapport",
"Downloadable reports": "Rapporter til download",
"Drag and drop files here or click": "Tr\u00e6k og slip filer her eller klik",
"Drive financial efficiency. Identify operational waste, isolate expensive usage spikes, and deploy cost-compression strategies to actively shrink your energy bills and maximize your budget.": "Frem \u00f8konomisk effektivitet. Identificer driftsspild, isoler dyre forbrugsstigninger, og implementering af omkostningskomprimeringsstrategier for aktivt at reducere dine energiregninger og maksimere dit budget.",
"Drop the file here or": "Tr\u00e6k \u2019n\u2019 drop CSV-filer her",
"Dutch": "Hollandsk",
"EPAD": "EPAD",
"EPAD Price": "EPAD-pris",
"EPAD Share": "EPAD-andel",
"EPAD Type": "EPAD-type",
"EPAD kWh": "EPAD kWh",
"EUR (\u20ac)": "EUR (\u20ac)",
"Edit": "Opdater",
"Edit Contract": "Opdater kontrakt",
"Edit Corporate Group": "Rediger koncern",
"Edit Document Details": "Rediger dokumentoplysninger",
"Edit Feature": "Opdater funktion",
"Edit Historical Data Limit": "Rediger gr\u00e6nse for historiske data",
"Edit Module": "Opdater modul",
"Edit Partner": "Opdater partner",
"Edit Role": "Opdater rolle",
"Edit Subscription": "Opdater abonnementet",
"Edit User": "Opdater bruger",
"Edit User Company": "Opdater brugerens tilknyttede virksomhed",
"Effect Payment": "Effektbetaling",
"Effortless energy insights at your fingertips": "Ubesv\u00e6ret energiindsigt lige ved h\u00e5nden",
"Ekskl. moms": "Ekskl. moms",
"Electricity": "Elektricitet",
"Electricity Charge": "Elafgift",
"Electricity Meters": "Elm\u00e5lere",
"Electricity consumption": "Elektricitetsforbrug",
"Electricity measured in kWh": "Elektricitet (kWh)",
"Eliminate Operational Waste": "Elimin\u00e9r operationelt spild",
"Email": "Mail",
"Email Sent ": "E-mail sendt ",
"Email address": "Mail",
"Email is required.": "Mail mangler.",
"End": "Slut",
"End Date": "Slut dato",
"Energy": "Energi",
"Energy Chart Type": "Energi diagram",
"Energy Consumption": "Energiforbrug (kWh)",
"Energy Consumption (kWh)": "Energiforbrug (kWh)",
"Energy Contract": "Energikontrakter",
"Energy Date Future Years": "Energi \u2013 fremtidige \u00e5r",
"Energy Date Past Years": "Energidata fra tidligere \u00e5r",
"Energy Invoice": "Energifaktura",
"Energy Meters": "Energim\u00e5lere",
"Energy Prices": "Energipriser",
"Energy Procurement": "Energiindk\u00f8b",
"Energy Report": "Energirapport",
"Energy Statement": "Energierkl\u00e6ring",
"Energy Type": "Energitype",
"Energy Types": "Energityper",
"Energy report": "Energirapport",
"Energy type is required": "Energitype er p\u00e5kr\u00e6vet",
"English": "Engelsk",
"Enter description": "Indtast beskrivelse",
"Enter email": "Indtast mail",
"Enter email address": "Indtast mail",
"Enter email address to continue.": "Indtast e-mailadresse for at forts\u00e6tte.",
"Enter full name": "Indtast det fulde navn",
"Enter name": "Indtast navn",
"Enter password": "Indtast adgangskode",
"Enter password again": "Indtast adgangskode igen",
"Error loading image:": "Billedet kan ikke hentes:",
"Error occurred while updating user": "Fejl ved opdatering af bruger",
"Error updating status": "Fejl ved opdatering af status",
"Error: Something went wrong!": "Fejl: Noget gik galt!",
"Error: Something went wrong! ": "Fejl: Noget gik galt! ",
"Estimate and configure your tailored energy services package. Adjust quantities and select your preferred billing interval and currency.": "Beregn og sammens\u00e6t din skr\u00e6ddersyede pakke med energitjenester. Juster m\u00e6ngderne, og v\u00e6lg den \u00f8nskede faktureringsperiode og valuta.",
"Excel Reports": "Excel-rapporter",
"Excel export": "Excel-eksport",
"Exchange": "B\u00f8rs",
"Excluded": "Eksklusiv",
"Expire At": "Udl\u00f8ber ved",
"Export": "Eksport\u00e9r",
"Export Baseline Data": "Eksporter basislinjedata",
"Export Carbon Metrics": "Eksporter klimadata",
"Export to Excel": "Eksporter til Excel",
"Fabeke": "Fabeke",
"Fabeke Data": "Fabeke data",
"Fabeke follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.": "Fabeke f\u00f8lger en standardprocedure med brug af logfiler. Disse filer logger bes\u00f8gende, n\u00e5r de bes\u00f8ger hjemmesider. Alle hostingfirmaer g\u00f8r dette, og det er en del af hostingtjenesternes analyse. De oplysninger, der indsamles af logfiler, omfatter IP-adresser (Internet Protocol), browsertype, internetudbyder (ISP), dato- og tidsstempel, henvisnings-/udgangssider og muligvis antallet af klik. Disse er ikke knyttet til nogen oplysninger, der er personligt identificerbare. Form\u00e5let med oplysningerne er at analysere tendenser, administrere webstedet, spore brugernes bev\u00e6gelser p\u00e5 webstedet og indsamle demografiske oplysninger.",
"Fabeke's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.": "Fabekes privatlivspolitik g\u00e6lder ikke for andre annonc\u00f8rer eller hjemmesider. Derfor r\u00e5der vi dig til at konsultere de respektive privatlivspolitikker for disse tredjeparts annonceservere for mere detaljerede oplysninger. Det kan omfatte deres praksis og instruktioner om, hvordan man frav\u00e6lger visse muligheder.",
"Failed to delete Corporate Group": "Kunne ikke slette koncernen",
"Failed to delete document": "Det lykkedes ikke at slette dokumentet",
"Failed to load document preview. Please try downloading the document.": "Det lykkedes ikke at indl\u00e6se dokumentforh\u00e5ndsvisning. Pr\u00f8v at downloade dokumentet.",
"Failed to refresh data": "Kunne ikke opdatere data",
"Failed to save setting.": "Kunne ikke gemme indstillingerne",
"Failed to save settings": "Kunne ikke gemme indstillingerne",
"Failed to unlink. ": "Det lykkedes ikke at fjerne linket. ",
"Failed to update status": "Kunne ikke opdatere status",
"Failed to update user status": "Har opdateret %s user(s) status til slettet",
"Feature": "Funktion",
"Feature Name": "Funktions navn",
"Feature key, Alpha numeric and dash only": "Funktionstast, kun alfanumerisk og bindestreg",
"Features": "Funktioner",
"Features for ": "Funktioner til ",
"Feb": "Feb",
"Feb: Checking": "Feb: Tjekker",
"Feb: Get": "Henter Feb data",
"Feb: Update": "Feb: Opdaterer",
"February": "Februar",
"Feed Accounting Systems": "Regnskabssystemer for foder",
"Feel free to reach out to Customer Service. They are around 24/7 to help you.": "Du er velkommen til at kontakte kundeservice. De er der 24/7 for at hj\u00e6lpe dig.",
"File Name": "Fil Navn",
"File type not supported": "Filtype underst\u00f8ttes ikke",
"Financial Year Start": "Regnskabs\u00e5rets start",
"Finds users with the role 'company-owner' (or custom role) who have no corporate groups (tenants) and sets their status to 'Deleted'.": "Finder brugere med rollen 'company-owner' (eller en brugerdefineret rolle), der ikke er tilknyttet nogen virksomhedsgrupper (tenants), og angiver deres status som 'Slettet'.",
"Fixed Price": "Fastpris",
"Fixed price": "Fastpris",
"Fixed price ex epad": "Fastpris ex EPAD",
"Fixed price ex epad and profile": "Fastpris ex EPAD og profil",
"Fixed price ex profile": "Fastpris ex profil",
"Fixed profile ex spot": "Fast profil ex spot",
"Flexible Subscriptions": "Fleksible abonnementer",
"For further information, please read CO2 emissions from Energistyrelsen: https://www.energidataservice.dk/tso-electricity/CO2Emis ": "For yderligere information, l\u00e6s venligst CO2-udledning fra Energistyrelsen: https://www.energidataservice.dk/tso-electricity/CO2Emis ",
"Forgot Password": "Glemt adgangskode",
"Forgot Your Password?": "Glemt din adgangskode?",
"Forgot your password?": "Glemt din adgangskode?",
"Found %s user(s) matching '%role%' without any corporate group whose status is not yet 'Deleted'. Click the button on the right to set their status to 'Deleted'.": "Der blev fundet %s bruger(e), der matcher '%role%', og som ikke er tilknyttet en koncern, og hvis status endnu ikke er 'Slettet'. Klik p\u00e5 knappen til h\u00f8jre for at \u00e6ndre deres status til 'Slettet'.",
"French": "Fransk",
"From": "Fra",
"From date is required": "Fra-dato er p\u00e5kr\u00e6vet",
"Full Name": "Fulde Navn",
"Full Year": "Hele \u00e5ret",
"Gain control of your energy spending": "F\u00e5 kontrol over dit energiforbrug",
"Gas": "Gas",
"Gas Meters": "Gasm\u00e5lere",
"Generate API Key": "Generer API-\nn\u00f8gle",
"Generate Budget Report": "Generer budgetrapport",
"Generate Climate Report": "Generer klimarapport",
"Generate Cost Report": "Generer omkostningsrapport",
"Generate Email": "Generer e-mail",
"Generate Energy Report": "Generer energirapport",
"Generate Sport Price Report": "Generer sportsprisrapport",
"Generate Tariff Report": "Generer tarifrapport",
"Generating Excel file": "Generering af Excel-fil",
"German": "Tysk",
"Get Full Visibility Over Your Energy Spending With Less Manual Work": "F\u00e5 fuld synlighed over dit energiforbrug med mindre manuelt arbejde",
"Get the exact data you need, precisely when and how you need it. Our reporting tools turn complex energy metrics into clear, actionable insights for your team or stakeholders.": "F\u00e5 pr\u00e6cis de data, du har brug for \u2013 n\u00f8jagtigt n\u00e5r og hvordan du har brug for dem. Vores rapporteringsv\u00e6rkt\u00f8jer omdanner komplekse energidata til klar og handlingsorienteret indsigt for dit team eller dine interessenter.",
"Getting Data": "Hentning af data",
"Global Keys": "Globale n\u00f8gler",
"Go Back": "Tilbage",
"Go to App": "G\u00e5 til app",
"Go to Dashboard": "G\u00e5 til Kontrolpanel",
"Grand Total": "Samlet Bel\u00f8b",
"Green Certificates": "Gr\u00f8nne certifikater",
"Grid": "Net",
"Grid (DKK/m\u00b3)": "Net (DKK/m\u00b3)",
"Grid (\u00d8re/kWh)": "Net (\u00d8re/kWh)",
"Grid company": "Netselskab",
"Grid in (DKK/m\u00b3)": "Net i (DKK/m\u00b3)",
"Grid in (\u00d8re/kWh)": "Net i (\u00d8re/kWh)",
"Heating": "Varme",
"Heating Meters": "Varmem\u00e5lere",
"Historical Data": "Historiske data",
"Historical Data Limits": "Historiske datagr\u00e6nser",
"Hour": "Time",
"Hour Report - Under development": "Timerapport - produceres ",
"Hourly": "Hver time",
"Hours": "Timer",
"House No.": "Husnr.",
"How many buildings company have": "M\u00e5lerens officielle adresse (uden oplysninger om placering)",
"How many future years can the user select on the Budget page": "Hvor mange fremtidige \u00e5r kan brugeren v\u00e6lge p\u00e5 budgetsiden?",
"How many future years can the user select on the Climate page": "Hvor mange fremtidige \u00e5r kan brugeren v\u00e6lge p\u00e5 klimasiden?",
"How many future years can the user select on the Cost page": "Hvor mange fremtidige \u00e5r kan brugeren v\u00e6lge p\u00e5 siden Omkostninger?",
"How many future years can users select on the Energy page": "Hvor mange fremtidige \u00e5r kan brugerne v\u00e6lge p\u00e5 energisiden?",
"How many meters company have": "Hvor mange m\u00e5lere har virksomheden",
"How many past years can the user select on the Budget page": "Hvor mange tidligere \u00e5r kan brugeren v\u00e6lge p\u00e5 budgetsiden?",
"How many past years can the user select on the Climate page": "Hvor mange tidligere \u00e5r kan brugeren v\u00e6lge p\u00e5 klimasiden?",
"How many past years can the user select on the Cost page": "Hvor mange tidligere \u00e5r kan brugeren v\u00e6lge p\u00e5 siden Omkostninger?",
"How many past years can users select on the Energy page": "Hvor mange tidligere \u00e5r kan brugerne v\u00e6lge p\u00e5 energisiden?",
"Hydrogen": "Hydrogen",
"I agree with": "Jeg er enig med",
"ID": "ID",
"If the data is heavy, it may still be loading.": "Henter data.",
"If you want to set no limit, add 999 in the numeric field. If you want to give no access, you can handle that in the subscription plan features. However, to implement this historical data limit, you must attach it to the subscription plan.": "Hvis du ikke \u00f8nsker at s\u00e6tte nogen begr\u00e6nsning, skal du indtaste 999 i det numeriske felt. Hvis du ikke \u00f8nsker at give adgang, kan du h\u00e5ndtere dette i abonnementsplanens funktioner. For at implementere denne begr\u00e6nsning for historiske data skal du dog knytte den til abonnementsplanen.",
"InActive": "Inaktiv",
"Included": "Inklusiv",
"Information!": "Information!",
"Initial platform provisioning": "Indledende klarg\u00f8ring af platformen",
"Inkl. Moms": "Inkl. moms",
"Installation Numbers": "Aftagernr.",
"Installation number": "Aftagernummer",
"Installation number is required": "Installationsnummer er p\u00e5kr\u00e6vet",
"Integrate our energy intelligence directly into your existing infrastructure. Built for developers and data teams, our robust API lets you automate workflows and power your own internal applications with real-time data.": "Integrer vores energi-intelligens direkte i jeres eksisterende infrastruktur. Vores robuste API er udviklet til udviklere og datateams og g\u00f8r det muligt at automatisere arbejdsgange samt drive jeres egne interne applikationer med realtidsdata.",
"Integrate real-time financial tracking directly into your enterprise software. Programmatically pull current energy expenditures, monitor cost-compression metrics, and feed live utility pricing data straight into your accounting or ERP systems for automated budget management.": "Integrer \u00f8konomisk opf\u00f8lgning i realtid direkte i din virksomhedssoftware. Hent l\u00f8bende data om energiudgifter, overv\u00e5g n\u00f8gletal for omkostningsoptimering, og overf\u00f8r aktuelle forsyningspriser direkte til dine regnskabs- eller ERP-systemer med henblik p\u00e5 automatiseret budgetstyring.",
"Internet connection restored": "Internetforbindelsen er genoprettet",
"Interval": "Interval",
"Invite User": "Inviter bruger",
"Invoice Contact Person": "Faktura Kontaktperson",
"Invoice Details": "Faktura detaljer",
"Invoices": "Fakturaer",
"Isolate Peak Costs": "Isol\u00e9r spidsbelastningsomkostninger",
"It appears that no company is associated with your account.": "Det ser ud til, at der ikke er nogen virksomheder tilknyttet din konto.",
"It will download a zip file containing the PO and POT files. PO file will have the existing translations, and the POT file will have the latest text that requires translation. We can use the Poedit software to import the POT text into the PO file and translate it.": "Det vil downloade en zip-fil, der indeholder PO- og POT-filerne. PO-filen vil have de eksisterende overs\u00e6ttelser, og POT-filen vil have den seneste tekst, der kr\u00e6ver overs\u00e6ttelse. Vi kan bruge Poedit-softwaren til at importere POT-teksten til PO-filen og overs\u00e6tte den.",
"Item": "Emne",
"Items": "Emner",
"Jan": "Jan",
"Jan: Checking": "Jan: Tjekker",
"Jan: Get": "Henter Jan data",
"Jan: Update": "Jan: Opdaterer",
"January": "Januar",
"Japanese": "Japansk",
"Jul": "Jul",
"Jul: Checking": "Jul: Tjekker",
"Jul: Get": "Henter Jul data",
"Jul: Update": "Jul: Opdaterer",
"July": "Juli",
"Jun": "Jun",
"Jun: Checking": "Jun: Tjekker",
"Jun: Get": "Henter Jun data",
"Jun: Update": "Jun: Opdaterer",
"June": "Juni",
"Key": "N\u00f8gle",
"Key Name": "N\u00f8glenavn",
"Key, Alpha numeric and dash only": "N\u00f8gle, kun alfanumerisk og bindestreg",
"Kg CO\u2082e": "Kg CO\u2082e",
"Kg of CO\u2082e": "Kg CO\u2082e",
"Kilogram": "Kilogram",
"LPG": "LPG",
"Label": "Label",
"Language": "Sprog",
"Languages": "Sprog",
"Last Login": "Seneste login",
"Last Run": "Sidste chance",
"Last Seen": "Sidst set",
"Last date": "Sidste dato",
"Last seen": "Sidst set",
"Like any other website, Fabeke uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.": "Som alle andre hjemmesider bruger Fabeke \"cookies\". Disse cookies bruges til at gemme oplysninger, herunder de bes\u00f8gendes pr\u00e6ferencer og de sider p\u00e5 hjemmesiden, som den bes\u00f8gende har tilg\u00e5et eller bes\u00f8gt. Oplysningerne bruges til at optimere brugernes oplevelse ved at tilpasse vores websideindhold baseret p\u00e5 de bes\u00f8gendes browsertype og/eller andre oplysninger.",
"Link": "Link",
"Link User": "Tilknyt bruger",
"Link company": "Link virksomhed",
"Link user": "Tilknyt bruger",
"Linked": "Linked",
"List View": "Listevisning",
"List as": "List som",
"Loading": "Indl\u00e6ser",
"Loading security verification...": "Indl\u00e6ser sikkerhedsverifikation...",
"Loading users and corporate groups...": "Indl\u00e6ser brugere og koncerner\u2026",
"Loading...": "Indl\u00e6ser...",
"Location": "Lokation",
"Location and above level access": "Lokation og h\u00f8jere niveauer",
"Locations": "Lokationer",
"Locations / Meters": "Lokationer / M\u00e5lere",
"Locations for company: ": "Adresse for virksomheden: ",
"Login": "Log ind",
"Login As": "Log ind som",
"Login as": "Log ind som",
"Login code": "Login-kode",
"Login failed! Please try again": "Login mislykkedes! Pr\u00f8v venligst igen",
"Login successful. Redirecting.": "Login vellykket. Omdirigering.",
"Login with your new password right away.": "Log ind med din nye adgangskode med det samme.",
"Main Price Type": "Hovedpris Type",
"Manage and clean up users without associated corporate groups.": "Administrer og opryd i brugere uden tilknyttede virksomhedsgrupper.",
"Mandarin": "Mandarin",
"Mar": "Mar",
"Mar: Checking": "Mar: Tjekker",
"Mar: Get": "Henter Mar data",
"Mar: Update": "Mar: Opdaterer",
"March": "Marts",
"Mark As Read": "Marker som l\u00e6st",
"Mark Deleted": "Marker som slettet",
"Markup": "Markup",
"Markup Price": "Markup-pris",
"Markup Share": "Markup-andel",
"Master your usage and your footprint. Track real-time energy consumption alongside critical climate data to optimize your efficiency and seamlessly hit your sustainability targets.": "F\u00e5 styr p\u00e5 dit forbrug og dit klimaaftryk. Overv\u00e5g energiforbruget i realtid sidel\u00f8bende med kritiske klimadata for at optimere effektiviteten og uden problemer n\u00e5 dine b\u00e6redygtighedsm\u00e5l.",
"Max size supported 20MB": "Maksimal underst\u00f8ttet st\u00f8rrelse 20 MB",
"Maximize Your Budget": "Optimer jeres budget",
"May": "Maj",
"May: Checking": "Maj: Tjekker",
"May: Get": "Henter Maj data",
"May: Update": "Maj: Opdaterer",
"Message": "Besked",
"Meter": "M\u00e5lere",
"Meter Data": "M\u00e5lerdata",
"Meter List": "M\u00e5lerliste",
"Meter No": "M\u00e5lernr.",
"Meter and above level access": "M\u00e5lere og h\u00f8jere niveauer",
"Meter number": "M\u00e5lernummer",
"Meter reading end date": "Slutdato for m\u00e5lerafl\u00e6sning",
"Meter reading start date": "Startdato for m\u00e5lerafl\u00e6sning",
"Meters / Locations": "M\u00e5lere / Lokationer",
"Minimum Fee": "Minimumsafgift",
"Missing document id": "Manglende dokument-id",
"Modals": "Modaler",
"Module": "Modul",
"Module code, Alpha numeric and dash only": "Modulkode, kun alfanumerisk og bindestreg",
"Module name": "Modulnavn",
"Moms": "Moms",
"Monitor Emissions": "Overv\u00e5g emissioner",
"Monitored measurement points": "Overv\u00e5gede m\u00e5lepunkter",
"Month": "M\u00e5ned",
"Month Columns: Downloading": "Henter m\u00e5nedstal for hver kolonne",
"Month Columns: Processing": "Beregner m\u00e5nedstal for hver kolonne",
"Month Data: Downloading": "Henter m\u00e5nedstal",
"Month Data: Processing": "Beregner m\u00e5nedstal",
"Month Report - Under development": "M\u00e5nedsrapport - produceres",
"Monthly": "M\u00e5nedlig",
"Monthly Statement": "M\u00e5nedsopg\u00f8relse",
"Months": "M\u00e5neder",
"My Account": "Min konto",
"My Profile": "Min profil",
"My Services": "Mine services",
"Name": "Navn",
"Name is required.": "Navn mangler.",
"Natural Gas": "Naturgas",
"Net": "Net",
"Net Tariff": "Nettarif",
"Never Login": "Aldrig logget ind",
"New": "Ny",
"New Password": "Ny adgangskode",
"No": "Nej",
"No Climate Report available for the selected filters.": "Der findes ingen klimarapport for de valgte filtre.",
"No Company": "Ingen virksomhed",
"No Documents Found": "Se dokument",
"No Energy Report available for the selected filters.": "Der findes ingen energirapport for de valgte filtre.",
"No Global Keys available. Please add a Global Key under the Global Keys tab first.": "Ingen globale n\u00f8gler tilg\u00e6ngelige. Tilf\u00f8j venligst f\u00f8rst en global n\u00f8gle under fanen Globale n\u00f8gler.",
"No Historical Data Limit": "Ingen begr\u00e6nsning p\u00e5 historiske data",
"No Limit": "Ingen gr\u00e6nse",
"No Partner": "Ingen partner",
"No Results Found!": "Ingen resultater fundet!",
"No Rows": "Ingen data",
"No Tariff Report available for the selected filters.": "Der findes ingen tarifrapport for de valgte filtre.",
"No active or inactive users without corporate groups found for the selected role. All matching orphaned users are already marked as Deleted.": "Der blev ikke fundet nogen aktive eller inaktive brugere uden koncerner for den valgte rolle. Alle matchende ikke tilknyttede brugere er allerede markeret som slettede.",
"No checkout session found.": "Ingen betalingssession fundet.",
"No company is currently associated with your partner account. As a result, some features are unavailable. Please contact us if you have any questions or need assistance.": "Der er i \u00f8jeblikket ingen virksomheder tilknyttet din partnerkonto. Derfor er nogle funktioner ikke tilg\u00e6ngelige. Kontakt os, hvis du har sp\u00f8rgsm\u00e5l eller brug for hj\u00e6lp.",
"No corporate group roles assigned": "Ingen koncernroller tildelt",
"No data found": "Der blev ikke fundet nogen data",
"No document available for preview": "Intet dokument tilg\u00e6ngeligt til forh\u00e5ndsvisning",
"No internet connection. Please check your network.": "Ingen internetforbindelse. Kontroller dit netv\u00e6rk.",
"No option available": "Bygning er ikke tilg\u00e6ngelig",
"No partner roles assigned": "Ingen partnerroller tildelt",
"No system roles assigned": "Ingen systemroller tildelt",
"No unread notifications": "Ingen ul\u00e6ste beskeder",
"No use of Fabeke's logo or other artwork will be allowed for linking absent a trademark license agreement.": "Ingen brug af Fabekes logo eller andre illustrationer vil blive tilladt til linking uden en varem\u00e6rkelicensaftale.",
"No users found in this view.": "Ingen brugere fundet i denne visning.",
"No users matching your search.": "Ingen brugere matcher din s\u00f8gning.",
"None (0)": "Ingen (0)",
"Norwegian": "Norsk",
"Not Applicable": "Ikke anvendelig",
"Not Available": "Ikke tilg\u00e6ngelig",
"Not Cached": "Ikke gemt i cache",
"Not Found": "Ikke fundet",
"Notes": "Noter",
"Notification has been deleted": "Meddelelsen er blevet slettet",
"Notification marked as read": "Meddelelse markeret som l\u00e6st",
"Notifications": "Beskeder",
"Nov": "Nov",
"Nov: Checking": "Nov: Tjekker",
"Nov: Get": "Henter Nov data",
"Nov: Update": "Nov: Opdaterer",
"November": "November",
"Number of administrative and viewer users with portal access.": "Antal administrative brugere og brugere med visningsadgang, der har adgang til portalen.",
"Number of corporate entities or subsidiary accounts required under the tenant.": "Antal virksomhedsenheder eller datterselskabskonti, der kr\u00e6ves under lejeren.",
"Number of distinct countries in which energy metrics are analyzed.": "Antal forskellige lande, hvor energim\u00e5leparametre analyseres.",
"Number of unique delivery points, facilities, or physical meters monitored.": "Antal unikke leveringspunkter, anl\u00e6g eller fysiske m\u00e5lere, der overv\u00e5ges.",
"Oct": "Okt",
"Oct: Checking": "Okt: Tjekker",
"Oct: Get": "Henter Okt data",
"Oct: Update": "Okt: Opdaterer",
"October": "Oktober",
"Official address of meter (not including location information)": "M\u00e5lerens officielle adresse (uden oplysninger om placering)",
"Often the number on company's bill": "Ofte nummeret p\u00e5 virksomhedens regning",
"Oil": "Olie",
"One Month Energy Consumption (kWh)": "En m\u00e5neds energiforbrug (kWh)",
"One Month Tariff (kWh)": "En m\u00e5neds tariff (kWh)",
"One-time Setup Fee": "Oprettelsesgebyr",
"One-time onboarding, system integration, custom branding, and workflow setup.": "Engangs-onboarding, systemintegration, skr\u00e6ddersyet branding og ops\u00e6tning af arbejdsgange.",
"One-time:": "Engangs-:",
"Only PDF files are allowed.": "Kun PDF-filer er tilladt.",
"Only PDF files are allowed. Leave empty to keep the existing file.": "Kun PDF-filer er tilladt. Lad feltet v\u00e6re tomt for at beholde den eksisterende fil.",
"Only for system level users": "Kun for brugere p\u00e5 systemniveau",
"Only lowercase alphanumeric characters and dashes are allowed": "Kun sm\u00e5 alfanumeriske tegn og bindestreger er tilladt",
"Operational nations scope": "Omfang af operationelle nationer",
"Optimize Footprint": "Optimer  CO2-aftryk",
"Order No": "Aftagernr.",
"Order Summary": "Ordreoversigt",
"Orphaned Users": "Ikke tilknyttede brugere",
"Others": "Andre",
"Overall statement": "Samlet opg\u00f8relse",
"Page Not Found": "Siden blev ikke fundet",
"Parameter showing Electricity consumption": "Parameter, der viser elforbruget",
"Parent / Child": "Moder/datter",
"Parent Companies": "Moderselskaber",
"Parent Company": "Moderselskab",
"Parent company and above level access": "Moderselskab og adgang til h\u00f8jere niveauer",
"Partner": "Partner",
"Partner Administration": "Partneradministration",
"Partner Companies": "Partnervirksomheder",
"Partner Keys": "Partnern\u00f8gler",
"Partner Roles": "Partnerroller",
"Partner Users": "Partnerbrugere",
"Partner Users for ": "Partnerbrugere til ",
"Partner and above level access": "Partner og h\u00f8jere adgangsniveau",
"Partners": "Partnere",
"Partnerships Team": "Team for partnerskaber",
"Password": "Adgangskode",
"Password Changed": "Adgangskode \u00e6ndret",
"Pay with Stripe": "Betal med Stripe",
"Payment Cancelled": "Betaling annulleret",
"Payment Success": "SuccesBetalingen lykkedes",
"Payment Successful!": "Betalingen lykkedes!",
"Payment confirmed but status update is pending. Please verify via your services dashboard.": "Betalingen er bekr\u00e6ftet, men statusopdateringen afventer. Tjek venligst via dit tjenestedashboard.",
"Payments are secured by Stripe. By proceeding, you agree to our Terms.": "Betalinger sikres af Stripe. Ved at forts\u00e6tte accepterer du vores vilk\u00e5r.",
"Pending Deletion": "Afventer sletning",
"Pending Deletion (Not Deleted)": "Afventer sletning (ikke slettet)",
"Period/Sum": "Periode/sum",
"Permissions": "Tilladelser",
"Permissions for ": "Tilladelser til ",
"Personal": "Personlig",
"Personal Information": "Personlig information",
"Platform License": "Licens",
"Platform License (x1)": "Platformslicens (x1)",
"Please also note to calculate the emission rate from CO2, the 125% method is used, which means that coproduced heat is produced by a given efficiency by 125%.": "Bem\u00e6rk ogs\u00e5, at for at beregne udledningen af CO2 anvendes 125%-metoden, hvilket betyder, at samproduceret varme produceres med en given effektivitet p\u00e5 125%.",
"Please authorize us on": "Godkend os venligst p\u00e5",
"Please enter a valid email and password!": "Indtast en gyldig e-mailadresse og adgangskode!",
"Please enter a valid email!": "Indtast mail!",
"Please enter a valid password!": "Indtast adgangskode!",
"Please hold on while we process your transactions.": "Vent venligst, mens vi behandler dine transaktioner.",
"Please select a file to upload": "Venligst v\u00e6lg en fil at uploade",
"Please wait": "Vent venligst",
"Please wait while security verification loads...": "Vent venligst, mens sikkerhedsverificeringen indl\u00e6ses...",
"Preparing stripe session...": "Forbereder stribe session...",
"Price": "Pris",
"Price (DKK/m\u00b3)": "Pris (DKK/m\u00b3)",
"Price (cent/kWh)": "Pris (cent/kWh)",
"Price (pence/kWh)": "Pris (pence/kWh)",
"Price (\u00d8re/kWh)": "Pris (\u00d8re/kWh)",
"Price (\u00f8re/kWh)": "Pris (\u00f8re/kWh)",
"Price Price": "Pris Pris",
"Price Share": "Pris-andel",
"Price Type": "Pristype",
"Price in (DKK/m\u00b3)": "Pris i (DKK/m\u00b3)",
"Price in (\u00d8re/kWh)": "Pris i (\u00d8re/kWh)",
"Price kWh": "Pris kWh",
"Price type": "Pristype",
"Price type is required": "Pristype er p\u00e5kr\u00e6vet",
"Prices": "Priser",
"Prices, tariffs, taxes and cost": "Priser, tariffer, afgifter og omkostninger",
"Privacy Policy": "Privatlivspolitik",
"Privacy Policy for Fabeke": "Privatlivspolitik for Fabeke",
"Proceed to Checkout": "G\u00e5 til kassen",
"Processing cancellation status...": "Behandler annulleringsstatus...",
"Procurement": "Procurement",
"Products": "Produkter",
"Profile": "Profil",
"Profile Price": "Profil pris",
"Profile Settings": "Profilindstillinger",
"Profile Share": "Profil-andel",
"Profile Type": "Profiltype",
"Profile kWh": "Profil kWh",
"Pull real-time carbon emissions and environmental footprint data straight into your software. Automate your sustainability tracking, feed greenhouse gas metrics directly into your compliance engines, and programmatically monitor your progress toward net-zero targets.": "Hent data om CO2-udledning og milj\u00f8aftryk i realtid direkte ind i din software. Automatiser din opf\u00f8lgning p\u00e5 b\u00e6redygtighed, overf\u00f8r n\u00f8gletal for drivhusgasser direkte til dine systemer til overholdelse af regler, og overv\u00e5g automatisk dine fremskridt mod m\u00e5lene om netto-nuludledning.",
"Q1": "Q1",
"Q2": "Q2",
"Q3": "Q3",
"Q4": "Q4",
"Qty:": "Antal:",
"Questions?": "Har du sp\u00f8rgsm\u00e5l?",
"Rabat Net Tariff": "Rabat Net Tariff",
"Read All Notifications": "L\u00e6s alle meddelelser",
"Read Notification": "L\u00e6s besked",
"Ready to enhance your offering? Talk to someone from our partnerships team today & start using ": "Er du klar til at forbedre dit tilbud? Tal med nogen fra vores partnerskabsteam i dag, og begynd at bruge ",
"Real-time, precise, and automated.": "Realtid, pr\u00e6cis og automatiseret.",
"Recurring Total": "Tilbagevendende total",
"Refresh Data": "Opdatere data",
"Register": "Registrer",
"Registered business companies": "Virksomheder",
"Registered successful. Redirecting.": "Du er nu oprettet, og du sendes videre.",
"Reload Page": "Genindl\u00e6s side",
"Remove file": "Fjern fil",
"Report": "Rapport",
"Reports": "Rapporter",
"Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.": "Anmodning om, at en virksomhed, der indsamler en forbrugers personoplysninger, skal oplyse de kategorier og specifikke personoplysninger, som virksomheden har indsamlet om forbrugerne.",
"Request that a business that sells a consumer's personal data, not sell the consumer's personal data.": "Anmodning om, at en virksomhed, der s\u00e6lger en forbrugers personoplysninger, ikke s\u00e6lger forbrugerens personoplysninger.",
"Require all devices to sign in again with the new password.": "Kr\u00e6v, at alle enheder logger p\u00e5 igen med den nye adgangskode.",
"Reset Completed": "Nulstilling fuldf\u00f8rt",
"Reset Password": "Nulstil adgangskode",
"Reset Your Password": "Nulstil din adgangskode",
"Return to Dashboard": "Vend tilbage til Kontrolpanelet",
"Role": "Rolle",
"Role Specific Information": "Rollespecifik information",
"Role key, Alpha numeric and dash only": "Rolletast, kun alfanumerisk og bindestreg",
"Roles": "Roller",
"SUM": "Total",
"Save": "Gem",
"Save All For": "Gem alt for",
"Save All Settings": "Gem indstillinger",
"Save Changes": "Gem \u00e6ndringer",
"Save Profile": "Gem profil",
"Saving. Please wait.": "Gemmer. Vent venligst.",
"Scalable Pricing": "Skal\u00e9rbar priss\u00e6tning",
"Scraper List": "Scraper-liste",
"Scraper Log": "Scraper-log",
"Scraper Name": "Scraper navn",
"Seamless Contracting": "S\u00f8ml\u00f8s kontraktindg\u00e5else",
"Search": "S\u00f8g",
"Search by name, email, or status...": "S\u00f8g p\u00e5 navn, e-mail eller status...",
"See All Notifications": "Se alle beskeder",
"Select": "V\u00e6lg",
"Select Company": "V\u00e6lg virksomhed",
"Select Global Key": "V\u00e6lg en global n\u00f8gle",
"Select date range": "V\u00e6lg datointerval",
"Select the corporate group chart visualization type for budget forecasting and analytics.": "V\u00e6lg koncernens diagram for budgetdata.",
"Select the corporate group chart visualization type for climate and environmental data.": "V\u00e6lg koncernens diagram for klimadata.",
"Select the corporate group chart visualization type for cost and financial analytics.": "V\u00e6lg koncernens diagram for energiomkostningsdata.",
"Select the corporate group chart visualization type for energy consumption data.": "V\u00e6lg koncernens diagram for energidata.",
"Select the preferred chart visualization type for budget forecasting and analytics.": "V\u00e6lg den foretrukne diagramtype til budgetprognoser og analyse.",
"Select the preferred chart visualization type for climate and environmental data.": "V\u00e6lg den foretrukne diagramtype til visualisering af klima- og milj\u00f8data.",
"Select the preferred chart visualization type for cost and financial analytics.": "V\u00e6lg den foretrukne diagramtype til analyse af omkostninger og \u00f8konomi.",
"Select the preferred chart visualization type for energy consumption data.": "V\u00e6lg den foretrukne diagramtype til visualisering af energiforbrugsdata.",
"Select your locality": "V\u00e6lg din lokalitet",
"Select your personal chart visualization preference for budget forecasting and analytics.": "V\u00e6lg din foretrukne visning af diagrammer til budgetprognoser og analyse.",
"Select your personal chart visualization preference for climate and environmental data.": "V\u00e6lg din foretrukne visning af grafer for klima- og milj\u00f8data.",
"Select your personal chart visualization preference for cost and financial analytics.": "V\u00e6lg din foretrukne visning af diagrammer til omkostnings- og \u00f8konomianalyser.",
"Select your personal chart visualization preference for energy consumption data.": "V\u00e6lg din foretrukne visning af grafer for energiforbrugsdata.",
"Send Link to Email": "Send link til e-mail",
"Send the user a notification via email.": "Send brugeren en notifikation via e-mail.",
"Sep": "Sep",
"Sep: Checking": "Sep: Tjekker",
"Sep: Get": "Henter Sep data",
"Sep: Update": "Sep: Opdaterer",
"September": "September",
"Services": "Services",
"Services & Billing Calculator": "Beregner for ydelser og fakturering",
"Session ID:": "emissionerSession ID:",
"Set Status to Deleted (%s)": "Har opdateret %s user(s) status til slettet",
"Set status to Deleted": "Set status til slettet",
"Setting updated successfully!": "Indstillingerne er opdateret",
"Settings": "Indstillinger",
"Settings Keys": "Indstillingsn\u00f8gler",
"Setup Fee (One-time)": "Oprettelsesgebyr (engangsbel\u00f8b)",
"Setup a unique password to protect your account.": "Opret en unik adgangskode for at beskytte din konto.",
"Share (%)": "Andel (%)",
"Show up to": "Vis op til",
"Showing %s user(s)": "Viser %s bruger(e)",
"Sign In": "Log ind",
"Sign Out": "Log ud",
"Sign Up": "Tilmeld dig",
"Sign in": "Log ind",
"Sign up": "Tilmeld dig",
"Simple": "Simpel",
"Simplify Compliance": "Simplificering af compliance",
"Simplify ESG Reporting": "Forenkl ESG-rapportering",
"Smart Analytics": "Smart analyse",
"Something Went Wrong": "Der er sket en fejl",
"Sorry, we couldn't find the page you're looking for. The link might be broken, or the page may have been moved or deleted.": "Beklager, vi kunne ikke finde den side, du leder efter. Linket kan v\u00e6re defekt, eller siden kan v\u00e6re blevet flyttet eller slettet.",
"Spanish": "Spansk",
"Spot (60%)": "Spot (60%)",
"Spot Better Deals": "Find bedre tilbud",
"Spot Premium Price": "Spottill\u00e6g",
"Spot Premium Share": "Spot andel",
"Spot Price": "Spotpris",
"Spot Prices": "Spotpriser",
"Spot premium": "Spottill\u00e6g",
"Spotpris": "Spotpris",
"Start": "Start",
"Start Date": "Start dato",
"Statement Export": "Eksporter rapport",
"Status": "Status",
"Status updated successfully": "Status opdateret med succes",
"Still Loading": "Henter data.",
"Stream Live Consumption": "Stream forbrug i realtid",
"Stream Live Emissions": "Stream live-udledningsdata",
"Stream Live Expenditures": "Stream udgifter i realtid",
"Stream live consumption data directly into your existing systems. Automate real-time tracking of your power usage, capture immediate usage spikes, and feed your internal dashboards with precise, programmatic energy metrics.": "Stream live-forbrugsdata direkte ind i dine eksisterende systemer. Automatis\u00e9r sporing af dit str\u00f8mforbrug i realtid, registr\u00e9r pludselige forbrugstoppe, og forsyn dine interne dashboards med pr\u00e6cise, programmatiske energidata.",
"Streamline your energy management, slash costs, and hit your sustainability goals with our all-in-one platform. We turn complex data into actionable power.": "Optimer din energistyring, reducer omkostningerne markant, og n\u00e5 dine b\u00e6redygtighedsm\u00e5l med vores alt-i-\u00e9n-platform. Vi omdanner komplekse data til konkret v\u00e6rdi.",
"Street": "Gade",
"Stripe payment session creation failed.": "Oprettelse af Stripe-betalingssession mislykkedes.",
"Subscription": "Abonnement",
"Subscription Expire At": "Abonnement udl\u00f8ber den",
"Subscription Expired!": "Abonnementet er udl\u00f8bet!",
"Subscription Expiring Soon!": "Abonnementet udl\u00f8ber snart!",
"Subscription Plan": "Abonnementsplan",
"Subscription Plan Name": "Abonnementets navn",
"Subscription Plan added Successfully": "Abonnement er blevet tilf\u00f8jet",
"Subscription Plans": "Abonnementer",
"Subscription key, Alpha numeric and dash only": "Abonnementsn\u00f8gle, kun alfanumerisk og bindestreg",
"Subscription updated Successfully": "Abonnementet er blevet opdateret",
"Subsidiaries / Companies": "Selskaber",
"Successfully updated %s user(s) to Deleted status": "Har opdateret %s user(s) status til slettet",
"Sum": "Sum",
"Sum/Average": "Sum/gennemsnit",
"Supplier": "Leverand\u00f8r",
"Supplier (DKK/m\u00b3)": "Leverand\u00f8r (DKK/m\u00b3)",
"Supplier (\u00d8re/kWh)": "Leverand\u00f8r (\u00d8re/kWh)",
"Supplier in (DKK/m\u00b3)": "Leverand\u00f8r i (DKK/m\u00b3)",
"Supplier in (\u00d8re/kWh)": "Leverand\u00f8r i (\u00d8re/kWh)",
"Support": "Support",
"Swedish": "Svensk",
"Switch as": "Skift som",
"Sync Carbon Metrics": "Synkroniser kulstofdata",
"System": "System",
"System Administration": "Systemadministration",
"System Partners": "Systempartnere",
"System Price": "System\npris",
"System Roles": "System roller",
"System Settings": "Systemindstillinger",
"System Share": "System-andel",
"System Tariff": "Systemtarif",
"System Type": "Systemtype",
"System Users": "Systembrugere",
"System kWh": "System kWh",
"TSO - System Subscription": "TSO - Systemabonnement",
"Take control of your energy expenses with": "F\u00e5 styr p\u00e5 dine energiudgifter med",
"Target Role Filter": "Filtrer for valgt rolle",
"Tariff": "Afgifter",
"Tariff Report": "Toldrapport",
"Tariff Statement": "Tarifopg\u00f8relse",
"Tax": "Afgifter",
"Taxes (DKK/m\u00b3)": "Afgifter (DKK/m\u00b3)",
"Taxes (\u00d8re/kWh)": "Afgifter (\u00d8re/kWh)",
"Taxes in (DKK/m\u00b3)": "Afgifter i (DKK/m\u00b3)",
"Taxes in (\u00d8re/kWh)": "Afgifter i (\u00d8re/kWh)",
"Terms & Conditions": "Betingelser & Aftaler",
"Test Climate Report": "Generer klimarapport til test",
"Test Energy Report": "Generer energirapport til test",
"Test Sport Price Report": "Generer prisrapport til test",
"Test report": "Test rapport",
"Thank you for registering with us. We're excited to have you on board!": "Tak, fordi du registrerede dig hos os. Vi er glade for at have dig om bord!",
"Thanks for signing up!": "Tak for tilmeldingen!",
"That is great that you know that.": "Det er dejligt, at du ved det.",
"The 2025 and 2026": "2025 og 2026",
"The Corporate Group has been updated.": "Koncernen er opdateret.",
"The POC has been updated.": "POC'en er blevet opdateret.",
"The cache has been cleared": "Cachen er blevet t\u00f8mt",
"The calculations for the CO2 emissions are based on emissions from each power plant above 10MW and where all power plants below 10MW is regarded as one power plant. Furthermore, the calculations are based on production per hour, consumption per hour and exchange per hour.": "Beregningerne af CO2-emissionerne er baseret p\u00e5 emissioner fra hvert kraftv\u00e6rk over 10 MW, og hvor alle kraftv\u00e6rker under 10 MW betragtes som \u00e9t kraftv\u00e6rk. Desuden er beregningerne baseret p\u00e5 produktion pr. time, forbrug pr. time og udveksling pr. time.",
"The company already linked.": "Virksomheden er allerede forbundet.",
"The company has been linked.": "Virksomheden er blevet forbundet.",
"The company has been unlinked.": "Virksomheden er blevet afkoblet.",
"The data limit has been updated": "Datagr\u00e6nsen er blevet opdateret",
"The deal has updated": "Aftalen er opdateret",
"The document has been uploaded.": "Dokumentet er blevet uploadet.",
"The email has been sent": "Mailen er blevet sendt til dig",
"The file has been exported.": "Filen er blevet eksporteret.",
"The historical data limit has been added.": "Den historiske datagr\u00e6nse er blevet tilf\u00f8jet.",
"The mail already exists in the system!": "Mailen findes allerede i systemet!",
"The metering point id from datahub": "M\u00e5lepunktets id fra datahub",
"The module has been updated": "Modulet er blevet opdateret",
"The new Corporate Group has been added.": "Den nye koncern er tilf\u00f8jet.",
"The new POC has been added.": "Den nye POC er blevet tilf\u00f8jet.",
"The new deal has added": "Den nye aftale har tilf\u00f8jet",
"The new feature has been added": "Den nye funktion er blevet tilf\u00f8jet",
"The new module has been added": "Det nye modul er blevet tilf\u00f8jet",
"The new partner has been added.": "Den nye partner er blevet tilf\u00f8jet.",
"The new role has been added.": "Den nye rolle er blevet tilf\u00f8jet.",
"The new user has been added.": "Den nye bruger er blevet tilf\u00f8jet.",
"The partner has been updated.": "Partneren er blevet opdateret.",
"The password has been reset.": "Adgangskoden er blevet nulstillet.",
"The password has been updated.": "Adgangskoden er blevet opdateret.",
"The registration is by invitation only.": "Tilmelding er kun mulig efter invitation.",
"The role has been updated": "Rollen er blevet opdateret",
"The session has been expired.": "Sessionen er udl\u00f8bet.",
"The system is now creating the report, and you can download it shortly by clicking Download.": "Systemet laver nu rapporten, og du kan hente den ved at klikke p\u00e5 Rapporter om f\u00e5 minutter ved at klikke opdater p\u00e5 siden.",
"The user already linked.": "Brugeren har allerede linket.",
"The user has been linked.": "Brugeren er blevet linket.",
"The user has been unlinked.": "Brugeren er blevet inviteret.",
"The user has been updated": "Brugeren er blevet opdateret",
"The year cache has been updated": "Cache for \u00e5rsdata er opdateret",
"There are no documents matching your criteria.": "Der er ingen dokumenter, der matcher dine kriterier.",
"These terms and conditions outline the rules and regulations for the use of Fabeke's Website, located at https://www.fabeke.com": "Disse vilk\u00e5r og betingelser beskriver de regler og bestemmelser, der g\u00e6lder for brugen af Fabekes websted, som ligger p\u00e5 https://www.fabeke.com",
"Third Party Privacy Policies": "Tredjeparts privatlivspolitik",
"Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Fabeke, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.": "Tredjeparts annonceservere eller annoncenetv\u00e6rk bruger teknologier som cookies, JavaScript eller Web Beacons, der bruges i deres respektive reklamer og links, der vises p\u00e5 Fabeke, og som sendes direkte til brugernes browser. De modtager automatisk din IP-adresse, n\u00e5r dette sker. Disse teknologier bruges til at m\u00e5le effektiviteten af deres reklamekampagner og/eller til at personligg\u00f8re det reklameindhold, du ser p\u00e5 de hjemmesider, du bes\u00f8ger.",
"This is a heads-up, everyone! We've temporarily paused new registrations. But don't worry, we'll open them again shortly. Stay tuned!": "Dette er en advarsel til alle! Vi har midlertidigt sat nye registreringer p\u00e5 pause. Men bare rolig, vi \u00e5bner for dem igen inden l\u00e6nge. Hold \u00f8je med os!",
"This page is under construction.": "Denne side er ikke tilg\u00e6ngelig.",
"This will update their status column to 'Deleted' in the database. Deleted users will be hidden from default user lists and prevented from logging in.": "Dette vil opdatere deres statuskolonne til slettet i databasen. Slettede brugere vil blive skjult fra standardbrugerlister og forhindret i at logge ind.",
"Thumbnail View": "Miniaturevisning",
"Time Zone": "Tidszone",
"Timestamp of last encountered when requesting data from datahub": "Tidsstempel for det sidste tidspunkt, hvor der sidst blev anmodet om data fra datahub",
"Timezone": "Tidszone",
"To": "Til",
"To complete your registration and activate your account, please confirm your email address by clicking the below:": "For at fuldf\u00f8re din registrering og aktivere din konto skal du bekr\u00e6fte din e-mailadresse ved at klikke p\u00e5 nedenst\u00e5ende:",
"To date is required": "Til dato er p\u00e5kr\u00e6vet",
"To manage your data, we require the name of your": "For at administrere dine data har vi brug for navnet p\u00e5 din",
"Total Billed Annually": "Samlet \u00e5rlig fakturering",
"Total Billed Monthly": "Samlet m\u00e5nedlig fakturering",
"Total Electricity Charge": "Elafgift",
"Total Orphaned (0 Tenants)": "Samlet antal ikke tilknyttede uden ejere",
"Total offerings": "Samlet udbud",
"Total users in DB: %s | Total corporate groups: %s": "Koncern brugere: Samlet antal brugere i databasen: %s | Samlet antal virksomhedsgrupper: %s",
"Track Carbon Footprint": "F\u00f8lg \nCO2-aftryk",
"Track Live Usage": "F\u00f8lg live-forbrug",
"Track and manage your carbon footprint. Seamlessly map your energy consumption against precise emission factors to monitor greenhouse gas metrics, simplify compliance, and accelerate your path to net-zero.": "Spor og administrer dit CO2-aftryk. Hold styr p\u00e5 dit energiforbrug i forhold til pr\u00e6cise emissionsfaktorer for at overv\u00e5ge drivhusgasdata, forenkle overholdelse af regler og fremskynde vejen mod net-zero.",
"Track consumption and carbon footprint for different energy mediums (Max 2).": "Spor forbrug og CO2-aftryk for forskellige energikilder (maks. 2).",
"Translation": "Overs\u00e6ttelse",
"Transmission Grid Tariff": "Transmissions nettarif",
"Try Again": "Pr\u00f8v igen",
"Type": "Type",
"Type of meter. E17 = consumption, E18 = production": "M\u00e5lertype. E17 = forbrug, E18 = produktion",
"URL": "URL",
"Unable to load the Climate Report. Please try again or contact support.": "Det er ikke muligt at indl\u00e6se klimarapporten. Pr\u00f8v igen, eller kontakt supporten.",
"Unable to load the Energy Report. Please try again or contact support.": "Det er ikke muligt at indl\u00e6se energirapporten. Pr\u00f8v igen, eller kontakt supporten.",
"Unable to load the Tariff Report. Please try again or contact support.": "Det er ikke muligt at indl\u00e6se tarifrapport. Pr\u00f8v igen, eller kontakt supporten.",
"Under construction": "Under opbygning",
"Unit": "Enhed",
"Unknown Error Occurred !": "Der er opst\u00e5et en ukendt fejl!",
"Unknown error Occurred !": "Der er opst\u00e5et en ukendt fejl!",
"Unlink": "Fjern link",
"Update": "Opdateret",
"Update Roles": "Opdater roller",
"Update failed": "Opdatering mislykkedes",
"Update your Image and other data here.": "Opdater dit billede og andre data her.",
"Updated At": "Opdateret p\u00e5",
"Updated By": "Opdateret af",
"Updating user statuses to 'Deleted'...": "Opdaterer brugerstatusser til 'Slettet'...",
"Updating...": "Opdaterer...",
"Upload": "Upload",
"Upload Data": "Upload data",
"Upload Document Files": "Upload dokument",
"Upload New Document": "Upload nyt dokument",
"Upload New Document File (Optional)": "Upload nyt dokumentfil (valgfrit)",
"Upload PO file": "Upload PO-fil",
"Upload Po file": "Upload Po-fil",
"Uploaded": "Uploadet",
"Uploading": "Uploader",
"Uploading...": "Uploader \u2026",
"Use this page to update the application version. Once you change the version, the client-side application will automatically download and run the latest code from the server.": "Brug denne side til at opdatere programmets version. N\u00e5r du \u00e6ndrer versionen, vil applikationen p\u00e5 klientsiden automatisk hente og k\u00f8re den nyeste kode fra serveren.",
"Used:": "Brugt:",
"User %s marked as Deleted": "Bruger %s markeret som slettet",
"User Data": "Brugerdata",
"User ID is missing": "Bruger-ID mangler",
"User Keys": "Bruger n\u00f8gler",
"User Name": "Brugernavn",
"User Profile": "Brugerprofil",
"User Settings": "Brugerindstillinger",
"User Type": "Bruger type",
"User not found": "Brugeren blev ikke fundet",
"Users": "Brugere",
"Users for the business: ": "Brugere til virksomheden: ",
"Users for the corporate group: ": "Koncern brugere: ",
"Users with Target Role": "Brugere med valgt rolle",
"V_per_m2": "V_per_m2",
"Validating. Please wait.": "Validering. Vent venligst.",
"Validity end date": "Slutdato for gyldighed",
"Validity start date": "Startdato for gyldighed",
"Variable/Spot/Nordpool price": "Variabel/Spot/Nordpool-pris",
"Verification Successful": "Bekr\u00e6ftelse lykkedes",
"Verify Password": "Bekr\u00e6ft Adgangskode",
"Verifying permissions and preparing your view...": "Verificerer rettigheder og klarg\u00f8r din visning...",
"Version": "Version",
"Version Management": "Versionsstyring",
"View": "Vis",
"View Mode": "Vis tilstand",
"View meter details": "Se detaljer om m\u00e5leren",
"Volume (kWh)": "M\u00e6ngde (kWh)",
"Water": "Vand",
"Water Meters": "Vandm\u00e5lere",
"We couldn't find what you searched for": "Vi kunne ikke finde det, du s\u00f8gte efter",
"We employ the use of cookies. By accessing Fabeke, you agreed to use cookies in agreement with the Fabeke's Privacy Policy.": "Vi benytter os af cookies. Ved at tilg\u00e5 Fabeke accepterer du at bruge cookies i overensstemmelse med Fabekes privatlivspolitik.",
"We equip your business with the data, tools, and flexibility needed to optimize every aspect of your energy ecosystem.": "Vi udstyrer din virksomhed med de data, v\u00e6rkt\u00f8jer og den fleksibilitet, der skal til for at optimere alle aspekter af dit energi\u00f8kosystem.",
"We have updated the reports for last month, and you can download the reports by clicking below": "vi har opdateret rapporterne for sidste m\u00e5ned, og du kan hente rapporterne ved at klikke nedenfor",
"We need your first corporate group or company name to get started.": "Vi har brug for navnet p\u00e5 din f\u00f8rste koncern eller virksomhed for at komme i gang.",
"Web access": "Webadgang",
"Web services": "Webtjenester",
"Website": "Website",
"Welcome to": "Velkommen til",
"Welcome to ": "Velkommen til ",
"What do you know?": "Hvad ved du om det?",
"With Corporate Group": "Med koncern",
"Wrong password!": "Forkert adgangskode!",
"Year": "\u00c5r",
"Year Data: Downloading": "Henter \u00e5rstal",
"Year Data: Processing": "Beregner \u00e5rstal",
"Year Report - Under development": "\u00c5rsrapport - produceres",
"Year: Get": "Henter \u00e5rsdata",
"Year: Update": "Opdaterer \u00e5rsdata",
"Yearly": "\u00c5rlig",
"Yearly (12 months)": "\u00c5rligt (12 m\u00e5neder)",
"Years": "\u00c5r",
"Yes": "Ja",
"Yes I know that.": "Ja, det ved jeg godt.",
"Yes, Set Status to Deleted": "Set status til slettet",
"You are not authorized to perform this action": "Du har ikke rettigeder til at udf\u00f8re denne handling",
"You can change your password here": "Du kan opdatere din adgangskode her",
"You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browser's respective websites.": "Du kan v\u00e6lge at deaktivere cookies via dine individuelle browserindstillinger. Du kan finde mere detaljerede oplysninger om cookieh\u00e5ndtering med specifikke webbrowsere p\u00e5 browserens respektive websteder.",
"You can continue to use our services now. ": "Du kan forts\u00e6tte med at bruge vores tjenester nu. ",
"You can now use your new password to sign in to your account.": "Du kan nu bruge din nye adgangskode til at logge ind p\u00e5 din konto.",
"You can upload only the PO file. After uploading that file, it takes almost 10 minutes to reflect the changes on the website.": "Du kan kun uploade PO-filen. Efter upload af filen tager det n\u00e6sten 10 minutter at afspejle \u00e6ndringerne p\u00e5 hjemmesiden.",
"You don't have permission to access this page or resource. Please contact your system administrator if you believe this is an error.": "Du har ikke tilladelse til at f\u00e5 adgang til denne side eller ressource. Kontakt venligst din systemadministrator, hvis du mener, at der er tale om en fejl.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Du er blevet inviteret af {{partner_name}} til at tilmelde dig som {{role_name}}. For at forts\u00e6tte skal du klikke p\u00e5 Login for at f\u00e5 adgang til systemet.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Du er blevet inviteret af {{partner_name}} til at deltage som {{role_name}}. For at forts\u00e6tte skal du oprette en adgangskode for at f\u00e5 adgang til systemet.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Du er blevet inviteret af {{tenant_name}} til at tilmelde dig som {{role_name}}. For at forts\u00e6tte skal du klikke p\u00e5 Login for at f\u00e5 adgang til systemet.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Du er blevet inviteret af {{tenant_name}} til at deltage som {{role_name}}. For at forts\u00e6tte skal du oprette en adgangskode for at f\u00e5 adgang til systemet.",
"Your Picture": "Dit billede",
"Your account doesn\u2019t exist, please Sign Up": "Kontoen eksisterer ikke, v\u00e6r venlig at tilmelde dig",
"Your checkout transaction was cancelled or declined. No charges were made.": "Din betalingstransaktion blev annulleret eller afvist. Der blev ikke trukket nogen betaling.",
"Your login session has been expired. Please log in again": "Din login-session er udl\u00f8bet. Log venligst ind igen",
"Your password has been changed": "Din adgangskode er blevet opdateret",
"Your password has been successfully reset.": "Din adgangskode er nulstillet.",
"Your private file": "Din private fil",
"Your profile has been updated": "Din profil er blevet opdateret",
"Your subscription has expired. Renew now to regain access to your account and all premium features.": "Dit abonnement er udl\u00f8bet. Forny det nu for at f\u00e5 adgang til din konto og alle premium-funktioner igen.",
"Your subscription will expire in": "Dit abonnement udl\u00f8ber om",
"Your transaction has completed. The services have been successfully provisioned.": "Din transaktion er gennemf\u00f8rt. Tjenesterne er blevet oprettet med succes.",
"Zip Code": "Postnr.",
"Zone": "Zone",
"all": "Alle",
"and": "og",
"and Fabeke Tech does not take responsibility for any errors in submitted data and lists": "og Fabeke Tech tager ikke ansvar for eventuelle fejl i indsendte data og lister",
"browse": "browser",
"cache has been updated": "cachen er blevet opdateret",
"clicking the link we just emailed you at ": "ved at klikke p\u00e5 det link, vi lige har e-mailet dig p\u00e5 ",
"collects your energy data, prices and carbon emissions from all relevant data sources and present your energy consumption, prices, taxes, costs, and carbon emissions in our energy spending platform.": "indsamler dine energidata, priser og CO2-emissioner fra alle relevante datakilder og pr\u00e6senterer dit energiforbrug, priser, afgifter, omkostninger og CO2-emissioner i vores energiforbrugsplatform.",
"comprehensive data and insights": "omfattende data og indsigt",
"contact us": "kontakt os",
"conversion rates": "CO\u2082-aftryk",
"converts data into your language and local time zone": "konverterer data til dit sprog og din lokale tidszone",
"does not take responsibility for any errors in submitted data and lists": "p\u00e5tager sig ikke ansvaret for eventuelle fejl i indsendte data og lister",
"excl. VAT": "Ekskl. moms",
"export": "Eksport\u00e9r",
"export to CSV": "Eksporter til CSV",
"export to Excel": "Eksporter til Excel",
"export to PDF": "Eksport\u00e9r til PDF",
"files": "filer",
"for any queries.": "for eventuelle sp\u00f8rgsm\u00e5l.",
"g CO\u2082/kWh": "g CO\u2082e/kWh",
"g CO\u2082e/kWh": "g CO\u2082e/kWh",
"gives you": "giver dig",
"have not yet been released, so we use 2024 for those years until we have data.": "er endnu ikke offentliggjort, s\u00e5 vi bruger 2024 for disse \u00e5r, indtil vi har data.",
"https://www.example.com": "https://www.example.com",
"into your energy usage, costs, and carbon footprint.": "i dit energiforbrug, dine omkostninger og dit CO2-fodaftryk.",
"kWh": "kWh",
"measuring the Carbon dioxide Consumption. potential difference across a surface area, we use the unit carbon dioxide per square meter (Co2/m2)": "ved m\u00e5ling af kuldioxidforbruget. potentialforskellen over et overfladeareal bruger vi enheden kuldioxid pr. kvadratmeter (Co2/m2)",
"measuring the electrical potential difference across a surface area, we use the unit volts per square meter (V/m2)": "ved m\u00e5ling af den elektriske potentialforskel over et overfladeareal bruger vi enheden volt pr. kvadratmeter (V/m2)",
"month": "m\u00e5ned",
"month per company": "m\u00e5ned pr. virksomhed",
"month per country": "m\u00e5ned pr. land",
"month per location": "m\u00e5ned pr. lokation",
"month per unit": "m\u00e5ned pr. enhed",
"month per user": "m\u00e5ned pr. bruger",
"m\u00b3": "m\u00b3",
"or": "eller",
"page": "side",
"q": "q",
"real-time, accurate insights": "pr\u00e6cis indsigt i realtid",
"s": "s",
"s linking policy at any time. By": "s linkpolitik til enhver tid. Ved",
"s site.`)}": "s websted.`)}",
"ubscription Expire A": "Abonnement udl\u00f8ber A",
"v": "v"
},
"plural": "(n != 1)"
}